<template>
  <div
    class="stock-delay-apply-record tb"
    v-if="funcView.stock_delay_apply_record_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 搜索项 -->
        <el-form-item style="float: right; margin-right: 0;">
          <search-input
            v-model="formSearch.search"
            @fetch="onPageChange({ page: 1 })"
            :placeholder="$t('crm_stockDelayApplyRecord.ji_shen_hao')"
          ></search-input>
        </el-form-item>
        <el-form-item style="float:right;">
          <switch-button
            :link="link"
            ref="containerBtn"
          ></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('crm_stockDelayApplyRecord.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
            placeholder=""
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_stockDelayApplyRecord.shen_qing_shi_jian')">
          <custom-date-picker
            v-model="formSearch.dateTimes"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_stockDelayApplyRecord.sqrssgs')">
          <el-input v-model="formSearch.orgName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        tableCode="stock_delay_apply_record"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :data="tableList"
        :slots="['action']"
      >
        <template v-slot:action="scope">
          <span></span>
          <el-button
            type="text"
            size="mini"
            @click="checkDetail(scope.row)"
            v-if="funcView.stock_delay_apply_record_detail"
          >{{funcView.stock_delay_apply_record_detail}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <apply-record-dialog
      v-if="dialog1Visible"
      @close="dialog1Visible = false"
      :model="dialog1Model"
    ></apply-record-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import applyRecordDialog from './children/apply_record_dialog';

export default {
  name: 'stockDelayApplyRecord',
  mixins: [resetFormSearchMixins],
  components: {
    applyRecordDialog,
  },
  props: {},
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        dateTimes: [],
        orgName: '',
      },
      totalRows: null,
      tableList: [],
      dialog1Visible: false,
      dialog1Model: {},
      link: null,
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      const reqData = {
        ...this.formSearch
      };
      reqData.applyStartTime = this.formSearch.dateTimes[0] ? this.formSearch.dateTimes[0] : undefined;
      reqData.applyStartEndTime = this.formSearch.dateTimes[1] ? this.formSearch.dateTimes[1] : undefined;

      delete reqData.dateTimes;

      this.$getJSON(apis.stockOrderChangePage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    checkDetail(row) {
      this.dialog1Model = {
        title: this.$t('crm_stockDelayApplyRecord.kcyqsq'),
        data: {
          changeOrderId: row.changeOrderId,
        },
      };
      this.dialog1Visible = true;
    },
  },
  created() { },
  mounted() {
    this.getTableList();

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
};
</script>

<style>
</style>
